import { Logs } from 'components/Logs';

import { InvoiceTabProps } from './types';

export function InvoiceEvents({ invoice }: InvoiceTabProps): JSX.Element {
  return <Logs loading={false} logs={invoice.events} />;
}
